// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer {
  display: flex;
  margin: 0;
  padding: 0;
  flex-direction: column;
  background: var(--ion-white-primary);
  --background: var(--ion-white-primary);
}

.modalFooter {
  display: flex;
  margin: 0;
  padding: 2vw;
  flex-direction: row;
  gap: 2vw;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-white-primary);
  --background: var(--ion-white-primary);
}

app-button {
  height: 7vw;
  max-width: 7vw;
  min-width: 7vw;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/popup-modal/popup-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,oCAAA;EACE,sCAAA;AACJ;;AAEA;EACI,aAAA;EACF,SAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,oCAAA;EACE,sCAAA;AACJ;;AACA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAEF","sourcesContent":[".modalContainer{\n  display: flex;\n  margin: 0;\n  padding: 0;\n  flex-direction: column;\n  background: var(--ion-white-primary);\n    --background: var(--ion-white-primary);\n\n}\n.modalFooter{\n    display: flex;\n  margin: 0;\n  padding: 2vw;\n  flex-direction: row;\n  gap: 2vw;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--ion-white-primary);\n    --background: var(--ion-white-primary);\n}\napp-button{\n  height: 7vw;\n  max-width: 7vw;\n  min-width: 7vw;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
